<div class="flex flex-col h-screen bg-white">
  <!-- Update Banner -->
  @if (appUpdateState.updateBannerVisible) {
    <div class="w-full bg-yellow-100 border-b border-yellow-300 text-yellow-900 px-4 py-3 flex items-center justify-between z-50 shadow-sm">
      <span class="font-medium text-base">A new version of the app is available, please reload to get the latest version</span>
      <div class="flex gap-2">
        <button (click)="reloadApp()" class="px-3 py-1 rounded bg-yellow-300 text-yellow-900 font-semibold hover:bg-yellow-400 transition">Reload</button>
      </div>
    </div>
  }
  <app-platformheader *ngIf="loginDisplay && !isMfaRoute && !isResolvingPostLoginRoute" class="flex-shrink-0"></app-platformheader>
  <div class="flex flex-1 min-h-0 gap-2 lg:gap-4 pr-2 pt-3 pb-3 lg:p-4 transition-all duration-300 bg-background-page" [ngClass]="loginDisplay && isNavbarCollapsed ? 'lg:pl-4' : loginDisplay ? 'lg:pl-4' : 'pl-2 lg:pl-4'">
    <app-navbar *ngIf="loginDisplay && !isMfaRoute && !isResolvingPostLoginRoute" class="flex-shrink-0" (navbarToggled)="onNavbarToggled($event)"></app-navbar>
    <div class="flex-1 flex flex-col min-h-0">
      <!-- Main content area -->
      <div
        #scrollContainer
        [ngClass]="{'overflow-visible': !appScrollableState.scrollable(), 'overflow-auto': appScrollableState.scrollable()}"
        class="flex-1 min-h-0 px-1">
        <router-outlet (activate)="onRouteActivate(scrollContainer)"></router-outlet>
        @if (spinnerState.loading()) {
          <div
            tabindex="-1"
            class="fixed inset-0 z-50 flex justify-center items-center"
            >
            <div class="flex flex-col items-center gap-3 rounded-lg bg-white/95 px-6 py-5 shadow-xl">
              <app-spinner></app-spinner>
              @if (spinnerState.message()) {
                <p class="text-sm font-medium text-gray-800">
                  {{ spinnerState.message() | transloco }}
                </p>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<app-background-operation-pending-toast></app-background-operation-pending-toast>
<app-background-operation-result-modal></app-background-operation-result-modal>
